module.exports = __webpack_public_path__ + "img/img09.381921d4.png";